import script from "./EventHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./EventHeader.vue?vue&type=script&setup=true&lang=js"

import "./EventHeader.vue?vue&type=style&index=0&id=4db0872a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4db0872a"]])

export default __exports__